import ProgressIconMessage from './ProgressIconMessage';

export default ProgressIconMessage;
